import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { LoadScript } from "@react-google-maps/api";
import { BrowserRouter } from "react-router-dom";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoadScript
        language="ja-jp"
        googleMapsApiKey="AIzaSyCdYECfnT2yNmIX1W_QoRARWBud-1g3ja4"
        libraries={["places", "drawing"]}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LoadScript>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
